<template>
    <v-row class="ml-1 mr-1 mt-2 mb-2">
        <v-col>
            <v-card>
                <v-row class="ml-1 mr-1">
                    <v-col class="text-center">
                        Detalle
                    </v-col>
                    <v-col>
                        <v-btn class="float-right" small dark color="#1565C0" @click="generar">
                            <!-- <span>Asignar</span> -->
                            Generar Lotes por Fecha <v-icon title="Generar">keyboard_arrow_right</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row class="ml-1 mr-1">
                    <v-col>
                        <v-select
                            :items="tipo_lote_ingreso"
                            item-text="nombre"
                            item-value="id"
                            v-model="id_conf_lote"
                            label="Configurar Lote"
                            dense
                        ></v-select>
                    </v-col>
                    <v-col>
                        <v-select
                            :items="formatos"
                            item-text="formato"
                            item-value="id"
                            v-model="formato"
                            label="Seleccione Formato de ingreso"
                            dense
                        ></v-select>
                    </v-col>
                </v-row>
                <v-card-text class="bloque-maxis">
                    <v-row no-gutters>
                        <v-col cols="6" class="bloque1 pb-3">
                            <h3 class="text-center">Seleccionados</h3>
                            <v-row v-for="lote, idx in lotesIngreso" :key="idx">
                                <v-col>
                                    <p class="titulo-fecha">{{` LOTE: ${lote.nombre_lote.replace(/\([^()]*\)/, "("+lote.cantidad+")")} | Incremento: ${formatDate(lote.fecha_elab)} | Kilos: ${lote.suma_peso} ` }}</p>
                                    <v-row>
                                        <v-col cols="4" v-for="j in lote.jumbos" :key="j.id" class="ma-0 pt-0 pr-2 pl-4 pb-0">
                                            {{` ${j.nro_jumbo} (${j.peso} ) ` }}
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="6" class="bloque2 pl-2 pb-3">
                            <h3 class="text-center">Propuesta</h3>
                            <v-row v-for="lote, idx in lotesPropuestos" :key="idx">
                                <v-col>
                                    <p class="titulo-fecha">{{` LOTE: ${lote.nombre_lote} (${lote.cantidad}) | Incremento: ${formatDate(lote.fecha_elab)} | Kilos: ${lote.suma_peso} | Saldo: ${lote.diferencia}` }}</p>
                                    <v-row>
                                        <v-col cols="4" v-for="j in lote.jumbos" :key="j.id" class="ma-0 pt-0 pr-2 pl-4 pb-0">
                                            {{` ${j.nro_jumbo} (${j.peso} ) ` }}
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col>
            <v-card>
                <v-row class="ml-1 mr-1">
                    <v-col>
                        <v-btn small dark color="#1565C0" @click="limpiar">
                            <v-icon>keyboard_arrow_left</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col><p>Maxisacos Obtenidos</p></v-col>
                </v-row>
                <v-divider></v-divider>
                <v-card-text class="bloque-maxis">
                    <v-row v-for="ls, idx in lotesPropuestos" :key="idx">
                        <v-col>
                            <v-row>
                                <v-col>
                                    <p class="titulo-fecha">
                                        {{`LOTE: ${ls.nombre_lote} (${ls.cantidad}) | Incremento: ${formatDate(ls.fecha_elab)}`}}
                                    </p>
                                </v-col>
                                <v-col>
                                    <v-text-field label="Lote de Ingreso" v-model="ls.lote_ingreso"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col v-for="j in ls.jumbos" :key="j.id" class="ma-0 pa-0">
                                    <v-switch :title="formatDate(j.fecha_elab)" v-model="j.switch" :label="`${j.nro_jumbo}`"></v-switch>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <h3>Total Kilos: {{ kilos }}</h3>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import { mapState,mapMutations } from 'vuex'
    import moment from 'moment'

    export default{
        props:{
            lotesOrigen: {
                type: Array,
                required: true
            },
            bodegaDestino: {
                type: Number,
                required: true
            },
            loteSelected: {
                type: Object,
                required: true
            },
            formatos: {
                type: Array,
                required: true
            }
        },
        data: () => {
            return {
                jumbos: [],
                fecha_jumbos: [],
                lote: {id:''},
                jumbos_repaso: [],
                checkbox_select: false,
                lote_ingreso:'',
                formato:2,
                add_letra:'-M',
                id_conf_lote:1,
                tipo_lote_ingreso:[{id:'1', add:'-M', nombre:'Lote de Reensaque'},{id:2, add:'', nombre:'Mantener Lote'},{id:3, add:'', nombre:'Mezcla de Lotes'}],
            }
        },
        methods : {

            async generar(){
                console.log("lotesPropuestos",this.lotesPropuestos)
            },

            limpiar(){
                this.jumbos = [];
            },
            formatDate(value) {
                if (value) {
                    return moment(String(value)).format('DD-MM-YYYY')
                }
            },
            ...mapMutations(['mostrarLoading', 'ocultarLoading']),
        },
        computed : {
            lotesIngreso(){
                /**retorna el id y nombre de los lotes distintos */
                const lotes = this.lotesOrigen.reduce((acumulador, lote) => {
                                lote.jumbos.forEach(jumbo => {
                                    const clave = `${lote.nombre_lote}-${jumbo.fecha_elab}`;
                                    if (!acumulador[clave]) {
                                        acumulador[clave] = {
                                            nombre_lote: lote.nombre_lote,
                                            fecha_elab: jumbo.fecha_elab,
                                            cantidad: lote.jumbos.filter(j => {return j.fecha_elab == jumbo.fecha_elab }).length,
                                            jumbos: [],
                                            suma_peso: 0
                                        };
                                    }
                                    acumulador[clave].jumbos.push(jumbo);
                                    acumulador[clave].suma_peso += jumbo.peso;
                                });
                                return acumulador;
                            }, {});
                // this.$emit('lotes-ingreso', lotes)
                return lotes;
            },


            lotesPropuestos(){
                /**retorna el id y nombre de los lotes distintos */
                let filtrado = this.formatos.filter(f => f.id == this.formato);
                let confLote = this.tipo_lote_ingreso.filter(f => f.id == this.id_conf_lote);
                if (confLote) {
                    this.add_letra = confLote[0].add;
                } else {
                    this.add_letra = '-M'
                }
                let peso = 1000;
                let formato_id = 1;
                if (filtrado.length > 0 ) {
                    peso = filtrado[0].formato;
                    formato_id = filtrado[0].id;
                }

                let newObj = {};
                this.jumbos = []
                for (let grupo in this.lotesIngreso) {
                    let jumbos = this.lotesIngreso[grupo].jumbos;
                    let pesoTotal = this.lotesIngreso[grupo].suma_peso;
                    let nuevosJumbos = [];
                    let numNuevosJumbos = Math.floor(pesoTotal / peso);
                    let jumboInicio = jumbos[0].nro_jumbo

                    for (let j = 0; j < numNuevosJumbos; j++) {
                        nuevosJumbos.push({ id: j, nro_jumbo: jumboInicio + j, lotes_id: jumbos[0].lotes_id, peso: peso, fecha_elab: jumbos[0].fecha_elab, switch: true });
                        this.jumbos.push({ id: j, nro_jumbo: jumboInicio + j, lotes_id: jumbos[0].lotes_id, peso: peso, fecha_elab: jumbos[0].fecha_elab, switch: true });
                    }
                    let new_peso = nuevosJumbos.length * peso
                    newObj[grupo] = {
                        nombre_lote: this.lotesIngreso[grupo].nombre_lote.replace(/\([^()]*\)/, "").trim(),
                        lote_ingreso: this.lotesIngreso[grupo].nombre_lote.replace(/\([^()]*\)/, "").trim()+this.add_letra,
                        fecha_elab: this.lotesIngreso[grupo].fecha_elab,
                        cantidad: nuevosJumbos.length,
                        jumbos: nuevosJumbos,
                        suma_peso: new_peso,
                        diferencia: (pesoTotal - new_peso)
                    };
                }
                console.log("propuesto", newObj)
                
                this.$emit('lotes-propuesta', newObj)
                return newObj;
            },



            jumbos_agregados(){
                let jbs = [];
                this.lotesIngreso.forEach(l => {
                    l.jumbos.forEach(j => {
                        jbs.push(j)
                    });
                });
                return jbs;
            },

            kilos(){
                return this.jumbos.reduce((suma, valor) => parseInt(suma) + parseInt(valor.peso),0);
            },

            jumbos_ordenados(){
                let jumbitos = []
                this.lotesOrigen.forEach((row)=>{
                    row.jumbos.forEach((j)=>{
                        jumbitos.push(j)
                    });
                });
                return this.jumbos = jumbitos.sort((a, b) => a.nro_jumbo - b.nro_jumbo);
            },

            ...mapState(['base_url','headers']),
        },
        components :{

        },

    }

</script>

<style scoped>
    .titulo-fecha {
        font-size: 14px;
        font-weight: bold;
        color: #2c3e50;
        margin-bottom: 20px;
        margin-top: 20px;
    }
    .bloque-maxis {
        background-color: #f2f2f2;
        border-radius: 5px;
        box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
        margin-bottom: 20px;
        padding: 30px;
    }
    .bloque1{
        border-color: #98adc2;
        border-style: solid ;
    }
    .bloque2{
        border-color: #a2b1c0;
        border-style: solid ;
        background-color: #f0e1e1;
    }
</style>